import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Faq} from "../../components-library/interface/faq";

@Component({
	selector: 'fb-blog-details-content-faq',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './blog-details-content-faq.component.html',
	styleUrls: ['./blog-details-content-faq.component.scss']
})
export class BlogDetailsContentFaqComponent {

	@Input()
	public faqs: Faq = {} as Faq;

	public activeIndex = -1;

	public triggerFaqHeading(i: number): void {
		if (i == this.activeIndex) {
			this.activeIndex = -1
		}
		else {
			this.activeIndex = i;
		}
	}
}
